module.exports = __webpack_public_path__ + "static/media/12.4ec8b5bd.jpg";